import { Dialog, Pane } from 'evergreen-ui';
import DiaryEntryForm from './DiaryEntryForm';
import { getPeriod } from './Diary/shiftPeriods';

const DescriptionDialog = ({ isShown, onClose, onSave, userId, selectedDate, shiftPeriod }) => {
  const handleEntryAdded = async () => {
    if (onSave) await onSave();
    if (onClose) onClose();
  };

  const period = shiftPeriod ? getPeriod(shiftPeriod) : null;
  const title = period ? `Descrizione — ${period.label}` : 'Aggiungi nota';

  return (
    <Dialog
      isShown={isShown}
      title={title}
      onCloseComplete={onClose}
      hasFooter={false}
      shouldAutoFocus={false}
    >
      <Pane>
        <DiaryEntryForm onEntryAdded={handleEntryAdded} userId={userId} selectedDate={selectedDate} shiftPeriod={shiftPeriod} />
      </Pane>
    </Dialog>
  );
};

export default DescriptionDialog;
